"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssociateMenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _useActions = require("../context/useActions");

const AssociateMenuItem = ({
  equipRuleIds,
  onShowModal,
  children,
  ...props
}) => {
  const {
    showModal
  } = (0, _useActions.useActions)();
  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
    onClick: () => {
      showModal(equipRuleIds);

      if (onShowModal != null) {
        onShowModal();
      }
    }
  }, props), children);
};

exports.AssociateMenuItem = AssociateMenuItem;